import type { ReactionId } from '../shared/index.js';

export const s = {
  name: 'Gizli İtiraflar',
  pitch: 'İsimsiz itiraf yaz, kimin yazdığını bil',
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    mode: 'Ne itiraf edilsin',
    modeTopics: 'Her tur bir konu',
    modeFree: 'Serbest itiraf',
    modeHint: { topics: 'Her tur herkes aynı konuda yazar.', free: 'Konu yok; aklına gelen herhangi bir itirafı yaz.' },
    categories: 'Konu kategorileri',
    cesurHint: '+18 kategoriler açık cinsel içerik içerir; yalnızca yetişkinler içindir.',
    coupleHint: 'Çift odası: partnerinle ikiniz için. Konular partnerinle ilgili; pas hakkı her zaman var, durmak isteyen durdurur.',
    write: 'Yazma süresi',
    guess: 'Tahmin süresi',
    rounds: 'Tur sayısı',
    unlimited: 'Sınırsız',
    untimed: 'Süresiz',
    sec: (n: number) => `${n} sn`,
    roundsHint: (n: number) => (n === 0 ? 'Oda sahibi “Oyunu bitir” diyene kadar sürer.' : `${n} tur sonra podyum.`),
    hidden: 'Yazar açıklanmasın',
    hiddenHint: 'Tamamen anonim: kimin yazdığı hiç söylenmez, yalnızca tahmin dağılımı görünür. Kimse puan almaz.',
    on: 'Açık',
    off: 'Kapalı',
    addPrompt: 'Konu ekle',
    addPromptHint: 'Eklediğin konu “Arkadaş konuları” kategorisine girer ve sonraki oyunlarda çıkabilir.',
    promptPlaceholder: 'Örneğin: Kimseye söylemediğin bir hayalin',
    save: 'Konuyu ekle',
    saving: 'Ekleniyor…',
    saved: 'Konu eklendi.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Tur ${n}/${total}` : `Tur ${n}`),
    writePhase: 'Yaz',
    topicLabel: 'Bu turun konusu',
    secs: (n: number) => `${n} sn`,
    you: 'sen',
    me: 'Bu benim',
    freeTopic: 'Serbest itiraf',
    freeTopicHint: 'Aklına gelen, kimsenin bilmediği bir şey yaz.',
    untimed: 'Süresiz',
    placeholder: 'İtirafını yaz. İsmin görünmeyecek.',
    send: 'İtirafı gönder',
    update: 'İtirafı güncelle',
    sent: 'İtirafın gönderildi. Süre bitene kadar değiştirebilirsin.',
    privacy: 'Kimin yazdığını açıklamaya kadar yalnızca sen bilirsin.',
    privacyHidden: 'Bu turda yazarlar hiç açıklanmayacak.',
    wroteTitle: 'Yazanlar',
    wrote: 'yazdı',
    waiting: 'yazıyor',
    closeWriting: 'Yazmayı bitir',
    closeWritingHint: 'Yazanların itiraflarıyla tahmine geçilir.',
    confessionOf: (i: number, n: number) => `İtiraf ${i}/${n}`,
    whoWrote: 'Sence kim yazdı?',
    whoWroteHint: 'Herkes bir seçim yapar, yazan dahil. Kendi itirafınsa da birini seç; seçimin sayılmaz ve kimse anlamaz.',
    whoWroteHidden: 'Yazar açıklanmayacak; yalnızca kimin kaç oy aldığı görünecek.',
    picked: (n: number, total: number) => `${n}/${total} kişi seçti`,
    myPick: (nick: string, n: number, total: number) => `Seçimin: ${nick}. ${n}/${total} kişi seçti.`,
    changePick: 'Süre bitene kadar değiştirebilirsin.',
    author: (nick: string) => `Yazan: ${nick}`,
    gotIt: 'Bildin!',
    missed: 'Bilemedin.',
    hiddenText: 'Bu itiraf oda sahibi tarafından gizlendi.',
    hide: 'İtirafı gizle',
    closeGuess: 'Tahmini bitir',
    next: 'Sıradaki itiraf',
    nextRound: 'Sonraki tura geç',
    finish: 'Podyuma geç',
    revealTitle: 'Yazan',
    revealHidden: 'Yazar gizli kalıyor',
    nobodyRight: 'Kimse bilemedi.',
    rightList: (names: string) => `Bilenler: ${names}`,
    fooled: (nick: string, n: number) => (n > 0 ? `${nick}, ${n} kişiyi yanılttı.` : `${nick} kimseyi yanıltamadı.`),
    fooledMe: (n: number) => (n > 0 ? `Sen ${n} kişiyi yanılttın.` : 'Kimseyi yanıltamadın.'),
    tally: 'Kime kaç oy',
    votes: (n: number) => `${n} oy`,
    reactions: { yok: 'Yok artık', bende: 'Ben de!', efsane: 'Efsane', olamaz: 'Olamaz' } satisfies Record<ReactionId, string>,
    summaryTitle: (n: number) => `Tur ${n} bitti`,
    summaryEmpty: 'Bu turda kimse itiraf yazmadı.',
    summaryNext: 'Sonraki tur birazdan başlıyor.',
    summaryLast: 'Podyum birazdan.',
    by: (nick: string) => `${nick} yazdı`,
    anonymous: 'Anonim',
    scores: 'Puanlar',
    pts: (n: number) => `${n} puan`,
    detail: (c: number, f: number) => `${c} doğru, ${f} yanıltma`,
  },
  podium: {
    title: 'Oyun bitti',
    winner: (nick: string) => `${nick} kazandı!`,
    draw: 'Berabere',
    anonymous: 'Sırlar sırrınız olarak kaldı',
    detective: 'En iyi dedektif',
    trickster: 'En iyi yanıltıcı',
    none: 'Henüz kimse',
    detectiveValue: (n: number) => `${n} doğru tahmin`,
    tricksterValue: (n: number) => `${n} kişiyi yanılttı`,
    confessions: (n: number) => `Bu oyunda ${n} itiraf yazıldı.`,
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Yaz', 'Her tur bir konu çıkar. Herkes isimsiz bir itiraf yazar; kimin yazdığını yalnızca yazan bilir.'],
      ['Tahmin et', 'İtiraflar karışık sırayla tek tek gelir. Herkes kimin yazdığını seçer. Kendi itirafındaysan da birini seç; seçimin sayılmaz.'],
      ['Açıklama', 'Herkes seçince ya da süre bitince yazan açıklanır. Doğru bilen 1 puan, yazan da yanılttığı her kişi için 1 puan alır.'],
      ['Tepki ver', '“Yok artık”, “Ben de!” gibi tepkiler isimsizdir. Oda sahibi uygunsuz bir itirafı gizleyebilir.'],
    ] as [string, string][],
  },
};
